import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0e1878"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dynamic-component-demo",
  class: "demo"
}
const _hoisted_2 = ["onClick"]

import {computed, ref} from "vue";
import TabPosts from "@/components/BlogTabPosts.vue";
import TabHome from "@/components/BlogTabHome.vue";

// register components --> with script setup they wouldn't be found otherwise
// alternative pattern see out-commented script-tag below

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const components = {
  TabPosts,
  TabHome
}

const currentTab = ref('Home');
const tabs = ref(['Home', 'Posts']);
const currentTabComponent = computed(() => {
  const tabName = 'Tab' + currentTab.value;
  return components[tabName];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        onClick: ($event: any) => (currentTab.value=tab),
        key: tab,
        class: _normalizeClass(['tab-button', { active: currentTab.value === tab }])
      }, _toDisplayString(tab), 11, _hoisted_2))
    }), 128)),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentTabComponent))))
    ], 1024))
  ]))
}
}

})